// extracted by mini-css-extract-plugin
module.exports = {"container":"ArticlePage_container__Tdw_q","btn":"ArticlePage_btn__qoE2n"};